import DomainIcon from "@mui/icons-material/Domain";
import { BUILDINGS, DormitoryServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListBuildings from "./List";
import CreateBuilding from "./Create";
import EditBuilding from "./Edit";

export const resources = {
  isMenu: true,
  icon: <DomainIcon />,
  name: DormitoryServicePath + BUILDINGS,
  title: "Блокове",
  list: <ListBuildings />,
  create: <CreateBuilding />,
  createPermission: permissions.canManageDormitoryBuildings,
  edit: <EditBuilding />,
  editPermission: permissions.canManageDormitoryBuildings,
  permission: permissions.canPreviewDormitoryBuildings,
};
